import { render, staticRenderFns } from "./payments_admin.vue?vue&type=template&id=d1d10b06&scoped=true&"
import script from "./payments_admin.vue?vue&type=script&lang=js&"
export * from "./payments_admin.vue?vue&type=script&lang=js&"
import style0 from "./payments_admin.vue?vue&type=style&index=0&id=d1d10b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d10b06",
  null
  
)

export default component.exports